// Shared ID verification status model — verification lifecycle + SMS delivery, mapped to the 7 broker-facing states.
export const V_STATUS = {
  not_sent: { label: 'Not sent', dot: 'bg-slate-400', cls: 'bg-slate-100 text-slate-600 ring-slate-200' },
  sms_sent: { label: 'SMS sent', dot: 'bg-sky-500', cls: 'bg-sky-50 text-sky-700 ring-sky-100' },
  delivered: { label: 'Delivered', dot: 'bg-indigo-500', cls: 'bg-indigo-50 text-indigo-700 ring-indigo-100' },
  in_progress: { label: 'In progress', dot: 'bg-amber-500', cls: 'bg-amber-50 text-amber-800 ring-amber-100' },
  completed: { label: 'Completed', dot: 'bg-emerald-500', cls: 'bg-emerald-50 text-emerald-700 ring-emerald-100' },
  failed: { label: 'Failed', dot: 'bg-rose-500', cls: 'bg-rose-50 text-rose-700 ring-rose-100' },
  expired: { label: 'Expired', dot: 'bg-rose-300', cls: 'bg-rose-50/60 text-rose-600 ring-rose-100' },
};
export const SMS_STATUS = {
  sent: ['SMS sent', 'text-sky-700'], delivered: ['Delivered', 'text-indigo-700'], failed: ['Failed', 'text-rose-600'],
  not_configured: ['Not sent · SMS off', 'text-slate-500'], not_sent: ['Not sent', 'text-slate-500'],
};

const legacySent = (v) => (v.activity || []).some((a) => a.action === 'invite_sms_sent');
export const smsState = (v) => v.sms?.status || (legacySent(v) ? 'sent' : 'not_sent');
export const isExpired = (v) => ['link_created', 'customer_started'].includes(v.status) && v.expires_at && new Date(v.expires_at) < new Date();
export const needsReview = (v) => ['customer_submitted', 'broker_reviewed'].includes(v.status);
export const isOpen = (v) => ['link_created', 'customer_started'].includes(v.status) && !isExpired(v);

export function vState(v) {
  if (v.status === 'report_generated') return 'completed';
  if (isExpired(v)) return 'expired';
  if (v.status !== 'link_created') return 'in_progress';
  const s = smsState(v);
  return s === 'failed' ? 'failed' : s === 'delivered' ? 'delivered' : s === 'sent' ? 'sms_sent' : 'not_sent';
}

export const nameOf = (v) => `${v.first_name || ''} ${v.last_name || ''}`.trim() || v.customer_hint || 'Unnamed client';
export const fmt = (iso) => (iso ? new Date(iso).toLocaleString('en-AU', { day: '2-digit', month: 'short', hour: 'numeric', minute: '2-digit' }) : '—');
export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const invitedAt = (v) => v.sms?.sent_at || v.sms?.attempted_at || v.created_at;

// Same rule as the backend: AU mobiles must be 04xx xxx xxx (or +614…); other countries need full +country format.
export const validMobile = (m) => {
  const raw = String(m || '').replace(/[\s-()]/g, '');
  if (!raw) return false;
  let e = raw.startsWith('+') ? raw : raw.replace(/\D/g, '');
  if (!raw.startsWith('+')) e = e.startsWith('0') ? `+61${e.slice(1)}` : `+${e}`;
  if (!/^\+\d{8,15}$/.test(e)) return false;
  return e.startsWith('+61') ? /^\+614\d{8}$/.test(e) : true;
};
